import { MapPin, MessageCircle } from "lucide-react";
import { useLang } from "@/context";
import { waLink, SERVICE_IMAGES } from "@/i18n";
import { Reveal } from "./Reveal";

export const ServiceAreas = () => {
    const { t } = useLang();
    return (
        <section id="areas" data-testid="service-areas-section" className="relative py-20 sm:py-28 bg-[#2A0505] text-[#F7EEE8] overflow-hidden">
            <img src={SERVICE_IMAGES.area} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-[0.08]" loading="lazy" />
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                <Reveal className="max-w-2xl">
                    <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#C9A24B]">{t.nav.areas}</p>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight mt-3">{t.areas.heading}</h2>
                    <p className="text-base sm:text-lg text-[#D9C4BB] mt-4">{t.areas.sub}</p>
                </Reveal>

                <div className="flex flex-wrap gap-4 mt-10">
                    {t.areas.list.map((area, i) => (
                        <Reveal key={area} delay={i * 0.1}>
                            <div data-testid={`area-pill-${i}`} className="flex items-center gap-3 rounded-full border border-[#C9A24B]/30 bg-white/5 backdrop-blur px-7 py-4">
                                <MapPin className="w-5 h-5 text-[#C9A24B]" />
                                <span className="font-display text-xl sm:text-2xl font-bold">{area}</span>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.2}>
                    <div className="mt-12 rounded-3xl border border-white/10 bg-white/5 backdrop-blur p-8 sm:p-10 flex flex-col sm:flex-row sm:items-center gap-6 justify-between">
                        <div>
                            <h3 className="font-display text-2xl font-bold">{t.areas.notSureTitle}</h3>
                            <p className="text-sm sm:text-base text-[#D9C4BB] mt-2 max-w-lg">{t.areas.notSureText}</p>
                        </div>
                        <a
                            href={waLink("Hi Brighten Services, I want to check if you cover my area. My address / PIN code is: ")}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="areas-whatsapp-button"
                            className="inline-flex items-center justify-center gap-2 bg-[#22C55E] hover:bg-[#16A34A] text-white font-semibold rounded-full px-7 py-4 whitespace-nowrap transition-colors"
                        >
                            <MessageCircle className="w-5 h-5" />{t.areas.notSureCta}
                        </a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
